// ===================================================
// chatApi.js — 채팅 Edge Function 호출 래퍼 (프론트엔드용)
//
// 역할:
//   기존 브라우저에서 프롬프트 조립 + /api/gpt 호출하던 로직을
//   서버 측 Edge Function으로 이전했습니다.
//   이 파일은 얇은 래퍼만 남아 있습니다.
// ===================================================

import { getAuthToken } from './gptClient';

async function callEdge(url, body) {
  const token = await getAuthToken();
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || '일시적인 오류가 발생했어요.');
  }
  const { content, error } = await res.json();
  if (error) throw new Error(error);
  return content;
}

// 나와의 대화 — 과거 기록 기반 채팅 응답
export async function chatWithMemory(userMessage, sessionContexts = [], chatHistory = []) {
  return callEdge('/api/chat-send', { userMessage, sessionContexts, chatHistory });
}

// 기록 저장 후 인사이트 메시지 생성
export async function generatePostSaveInsight(initialText, rounds, mode) {
  return callEdge('/api/ai-utils', { action: 'postSaveInsight', initialText, rounds, mode });
}

// 기억 되살리기 — 첫 번째 AI 메시지 생성
export async function generateMemoryResurfacingIntro(session) {
  return callEdge('/api/ai-utils', { action: 'memoryResurfacingIntro', session });
}

// 기억 되살리기 — 두 번째 질문 생성
export async function generateMemoryResurfacingQ2(session, firstQuestion, userAnswer) {
  return callEdge('/api/ai-utils', { action: 'memoryResurfacingQ2', session, firstQuestion, userAnswer });
}

// 꿈과 목표 — 첫 행동 점검 메시지 생성
// dream 세션의 visionMeta를 참조하여 "첫 행동 해봤어?" 대화를 시작합니다.
export async function generateDreamFirstStepCheckIn(session) {
  return callEdge('/api/ai-utils', { action: 'dreamFirstStepCheckIn', session });
}
